import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isAuthenticated: false,
    token: null,
    units: [],
    activeUnit: null,
    signedEula: false,
    isFirstLogin: false,
    userType: null,
    user: null,
    deviceLogoutPending: false,
    authChecking: true
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login: (state, action) => {
            const units = action.payload.units || [];
            state.isAuthenticated = true;
            state.token = action.payload.token;
            state.units = units;
            // Check the serial number of the active unit, and match it with the units array
            // If it matches, update activeUnit with the corresponding unit in the UnitsArray. If not, set to first unit in the array or null if none exist
            const activeUnit = action.payload.activeUnit || state.activeUnit;
            if (activeUnit?.UnitSerNum) {
                const matchedUnit = units.find(unit => unit.UnitSerNum === activeUnit.UnitSerNum);
                state.activeUnit = matchedUnit || (units.length > 0 ? units[0] : null);
            } else {
                state.activeUnit = units.length > 0 ? units[0] : null;
            }
            state.isFirstLogin = action.payload.isFirstLogin;
            state.signedEula = action.payload.signedEula;
            state.userType = action.payload.user?.userType || null;
            state.user = action.payload.user || null;
            // Make sure to set authChecking to false upon login to prevent loops
            state.authChecking = false;
        },
        lockSession: (state) => {
            Object.assign(state, initialState, { authChecking: false });
        },
        logout: (state, action) => {
            Object.assign(state, initialState, { authChecking: false,
                deviceLogoutPending: action.payload?.explicitDeviceLogout === true });
        },
        finishDeviceLogout: state => { state.deviceLogoutPending = false; },
        setActiveUnit: (state, action) => {
            state.activeUnit = action.payload;
        },
        setSignedEula: (state, action) => {
            state.signedEula = action.payload.signedEula;
        },
        setFirstLogin: (state, action) => {
            state.isFirstLogin = action.payload;
        },
        setUserType: (state, action) => {
            state.userType = action.payload.userType;
        },
        setAuthChecking: (state, action) => {
            state.authChecking = action.payload;
        },
        setUser: (state, action) => {
            state.user = action.payload;
        }
    },
});

export const { login, logout, finishDeviceLogout, lockSession, setActiveUnit, setSignedEula, setFirstLogin, setUserType, setAuthChecking, setUser } = authSlice.actions;
export default authSlice.reducer;
